export default {
  setTourisms (state, tourisms) {
    state.tourisms = tourisms
  },

  setTourism (state, tourism) {
    state.tourism = tourism
  },

  setName (state, name) {
    state.name = name
  },

  setUrl (state, url) {
    state.url = url
  },

  setDescription (state, description) {
    state.description = description
  },

  setLat (state, lat) {
    state.lat  = lat
  },

  setLng (state, lng) {
    state.lng = lng
  },

  setRadius (state, radius) {
    state.radius = radius
  }
}
